import axios from "axios";
import React from "react";

import OtpInput from "react-otp-input";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import BZLogo from "../../components/BZLogo";
import { TwButton, TwMainLayout } from "../../components/tailwind";
import { classNames } from "../../helpers";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../redux/reducers/loadingReducer";
import { getUrlForUsers } from "../../utils/confighelpers";
import { useTranslation } from "react-i18next";
import I18nLanguageDropdown from "../../components/I18nLanguageDropdown";

export default function Verify({ }) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const [otp, setOtp] = React.useState("");
  const [error, setError] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [resendSMSSubmitting, setResendSMSSubmitting] = React.useState(false);
  const [numberToken, setNumberToken] = React.useState(
    location?.state?.response?.data?.token
  );

  const handleChange = (text) => setOtp(text);

  const handleResendSMS = async () => {
    setResendSMSSubmitting(true);
    dispatch(setActionLoading(true));
    dispatch(setGlobalLoading(true));
    const request = await axios.post(
      `${getUrlForUsers()}forgotPassword`,
      {
        username: location.state.countryCode + location.state.phone,
        userType: "teacher",
      }
    );
    dispatch(setActionLoading(false));
    dispatch(setGlobalLoading(false));
    if (request.data.statusCode === 200) {
      setResendSMSSubmitting(false);
      setNumberToken(request.data.data.token);
      addSuccessToast(request.data.message);
    } else {
      setResendSMSSubmitting(false);
      addErrorToast(request.data.message);
    }
  };

  const handleWrongNumber = () => {
    navigate(-1, {
      state: {
        formattedPhoneNumber: location.state.formattedPhoneNumber,
        countryName: location.state.countryName,
        countryCode: location.state.countryCode,
        phone: location.state.phone,
      },
    });
  };

  const handleSubmit = async () => {

    setError(false);
    if (otp === "") {
      setError(true);
      return false
    }
    setSubmitting(true);
    dispatch(setActionLoading(true));

    const request1 = await axios.put(
      `${getUrlForUsers()}verifyForgotPasswordOtp`,
      {
        code: otp,
        token: numberToken,
      }
    );
    dispatch(setActionLoading(false));

    if (request1.data.statusCode === 200) {
      navigate("/forgot-password/reset", {
        state: { verified: true, token: request1.data.data.token },
      });
    } else {
      addErrorToast(request1.data.message);
      setSubmitting(false);
      setError(true);
      return;
    }
  };

  if (!location.state) {
    navigate("/");
  }

  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <div className="min-h-screen bg-white flex flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="fixed top-5 right-5">
          <I18nLanguageDropdown />
        </div>

        <div className="sm:mx-auto sm:w-full sm:max-w-md flex flex-col gap-5">
          <BZLogo className="mx-auto" />
          {location.state && (<div className={"flex flex-col justify-center items-center gap-5 md:gap-8"}>
            <h2 className="text-center text-2xl md:text-3xl font-bold tracking-tight">
              {t("forgotPassword.verifyForgotTitle")}
            </h2>
            <p className={"text-sm text-center"}>
              {t("forgotPassword.verifyForgotSubTitle1")}<br />
              <span className="text-primary">
                {location?.state?.formattedPhoneNumber}
              </span>
              {t("forgotPassword.verifyForgotSubTitle2")}
            </p>
          </div>)}
        </div>

        {location.state && (<div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className={"flex flex-col gap-4"}>

            <OtpInput
              value={otp}
              onChange={handleChange}
              numInputs={4}
              containerStyle={`flex gap-4 justify-center`}
              inputStyle={classNames(`!size-16 text-sm/6 text-gray-900 placeholder:text-gray-400 sm:text-base disabled:bg-gray-200 rounded-xl bg-input-bz outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2`,
                error ? "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
                  : "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
              )}
              renderInput={(props) => <input {...props} />}
              hasErrored={error}
              shouldAutoFocus
              inputType="number"
            />
            <p className={"text-base md:text-lg text-center"}>
              {t("forgotPassword.verifyResendTitle")}{" "}
              <button
                type="button"
                className={
                  "text-lg text-indigo-bz font-bold transition-opacity active:opacity-50"
                }
                onClick={handleResendSMS}
                disabled={resendSMSSubmitting}
              >
                <p className={"text-base sm:text-sm md:text-sm text-[#9800FF]"}>{t("inputFieldsTitle.resendSms")}</p>
              </button>
            </p>
            <button
              className={
                "text-sm text-danger font-bold transition-opacity active:opacity-50 mb-4"
              }
              onClick={handleWrongNumber}
            >
              {t("inputFieldsTitle.wrongNumber")}
            </button>
            <TwButton
              variant={"secondary"}
              onClick={handleSubmit}
              disabled={loadingReduxState.actionLoading || submitting}
              actionLoading={(loadingReduxState.actionLoading)}
              className="w-full xs:text-base sm:text-xl md:py-3.5"
              type="submit"
            >
              {t("inputFieldsTitle.verifyNumber")}
            </TwButton>
          </div>
        </div>)}
      </div>
    </TwMainLayout>)
}
